import { useTranslation } from "react-i18next";
import { useState, useEffect } from "react";
import { Star } from "lucide-react";

const CARD_COLORS = [
{ bg: "bg-emerald-400" },
{ bg: "bg-yellow-400" },
{ bg: "bg-cyan-300" }];


const CARD_ROTATIONS = ["-rotate-3", "rotate-1", "-rotate-1"];

export const TestimonialsSection = () => {
  const { t } = useTranslation();
  const [startIndex, setStartIndex] = useState(0);

  const testimonials = t('testimonials.items', { returnObjects: true }) as Array<{
    text: string;
    author: string;
    location: string;
  }>;

  useEffect(() => {
    if (!testimonials?.length) return;
    const interval = setInterval(() => {
      setStartIndex((prev) => (prev + 3) % testimonials.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [testimonials?.length]);

  if (!testimonials?.length) return null;

  const visibleItems = Array.from({ length: 3 }, (_, i) =>
  testimonials[(startIndex + i) % testimonials.length]
  );

  return (
    <section id="testimonials" className="py-12 bg-background scroll-mt-20" aria-labelledby="testimonials-heading">
      <div className="container mx-auto px-4">
        <p className="text-sm font-medium tracking-widest uppercase text-center text-muted-foreground mb-3">
          Testimonials
        </p>
        <h2 id="testimonials-heading" className="text-4xl font-bold text-center mb-4">
          {t('testimonials.title')}
        </h2>
        <p className="text-center text-muted-foreground mb-12 max-w-2xl mx-auto">
          Real stories from adjusters and families we've served.
        </p>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {visibleItems.map((testimonial, index) =>
          <div
            key={`${startIndex}-${index}`}
            className={`${CARD_COLORS[index].bg} ${CARD_ROTATIONS[index]} rounded-md shadow-lg hover:rotate-0 transition-transform duration-300 cursor-default animate-fade-in`}>

              <div className="p-8">
                <p className="text-gray-900 text-base leading-relaxed mb-6 font-medium">
                  "{testimonial.text}"
                </p>
                <div className="mt-auto">
                  <p className="font-bold text-gray-900">{testimonial.author}</p>
                  <p className="text-gray-700 text-sm">{testimonial.location}</p>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Five Star Fridays */}
        <div className="mt-16 max-w-5xl mx-auto">
          <div className="text-center mb-8">
            <div className="flex items-center justify-center gap-2 mb-3">
              {Array.from({ length: 5 }).map((_, i) =>
              <Star key={i} className="w-6 h-6 fill-yellow-400 text-yellow-400" />
              )}
            </div>
            <h3 className="text-3xl font-bold mb-2">Five Star Fridays</h3>
            <p className="text-muted-foreground max-w-xl mx-auto text-center font-normal text-sm">Every Friday, Our team collaborates on the reviews submitted to TPS and celebrate the teams excellence in customer service.

            </p>
          </div>

        </div>
      </div>
    </section>);

};